import { updateListMethod } from "../../utils/list";
import {
  CLASS_UPDATE_LIST,
  CLASS_UPDATE_LIST_METHOD,
  CLASS_UPDATE_LIST_STUDENTS,
  CLASS_UPDATE_LIST_TEACHERS,
  CLASS_UPDATE_FORM,
  CLASS_UPDATE_FORM_ERROR,
  CLASS_UPDATE_FORM_FIELD,
  CLASS_UPDATE_PREVIEW,
  CLASS_UPDATE_DIALOG,
  CLASS_UNIT_OF_LEARNING_UPDATE_FORM
} from "../actions/class.actions";

const initialState = {
  list: [],
  totalList: 0,
  totalIds: [],
  form: {},
  oldForm: {},
  formError: {},
  preview: null,
  dialog: null,
  unitOfLearning: {},
};

const classesReducer = (state = initialState, action) => {
  const newState = { ...state };
  const { type, payload } = action;

  switch (type) {
    case CLASS_UPDATE_LIST:
      if (payload.curriculumId) {
        newState[payload.curriculumId] = {
          list: payload.data,
          totalList: payload.count,
          teachers: payload.teachers || [],
          students: payload.students || [],
          totalIds: payload.totalIds || [],
        };
      } else {
        newState.list = payload.data;
        newState.totalList = payload.count;
        newState.teachers = payload.teachers || [];
        newState.students = payload.students || [];
        newState.totalIds = payload.totalIds || [];
      }
      break;
    case CLASS_UPDATE_LIST_METHOD:
      if (payload.curriculumId) {
        if (newState[payload.curriculumId]) {
          newState[payload.curriculumId].list = updateListMethod(
            payload.method,
            payload.data,
            newState[payload.curriculumId].list
          );
          if (payload.method === "DELETE") {
            newState[payload.curriculumId].totalIds = newState[payload.curriculumId].totalIds
              .filter((row) => row.id !== payload.data._id);
            newState[payload.curriculumId].totalList--;
          }
          if (payload.method === "BATCH_DELETE") {
            newState[payload.curriculumId].totalIds = newState[payload.curriculumId].totalIds
              .filter((row) => !payload.data.includes(row.id));
            newState[payload.curriculumId].totalList -= payload.data.length;
          }
          if (payload.method === "POST") {
            newState[payload.curriculumId].totalIds.push({ _id: payload.data._id }); 
            newState[payload.curriculumId].totalList++;

          }
        } else {
          newState[payload.curriculumId] = {
            list: updateListMethod(payload.method, payload.data, []),
            totalList: 1,
            totalIds: [{ id: payload.data._id }],
            teachers: [],
            students: [],
          };
        }
      } else {
        newState.list = updateListMethod(
          payload.method,
          payload.data,
          newState.list
        );
        if (payload.method === "DELETE") {
          newState.totalIds = newState.totalIds.filter((row) => row.id !== payload.data.id);
          newState.totalList--;
        }
        if (payload.method === "POST") {
          newState.totalIds.push({ id: payload.data.id });
          newState.totalList++;
        }
      }
      break;
    case CLASS_UPDATE_LIST_STUDENTS:
      if (payload.curriculumId) {
        newState[payload.curriculumId].students = payload.list;
      }
      break;
    case CLASS_UPDATE_LIST_TEACHERS:
      if (payload.curriculumId) {
        newState[payload.curriculumId].teachers = payload.list;
      }
      break;
    case CLASS_UPDATE_FORM:
      newState.form = { ...payload };
      newState.oldForm = { ...payload };
      newState.formError = null;
      break;
    case CLASS_UPDATE_FORM_ERROR:
      newState.formError = payload;
      break;
    case CLASS_UPDATE_FORM_FIELD:
      if (payload.field === "curriculumElements") {
        newState.form = {
          ...newState.form,
          [payload.field]: payload.value,
          lcs: [],
        };
        newState.formError = {
          ...newState.formError,
          [payload.field]: null,
          lcs: null,
          elementId: null,
          subElementId: null,
        };
      } else {
        newState.form = { ...newState.form, [payload.field]: payload.value };
        newState.formError = { ...newState.formError, [payload.field]: null };
      }
      break;
    case CLASS_UPDATE_PREVIEW:
      newState.preview = payload;
      break;
    case CLASS_UPDATE_DIALOG:
      if (payload.open === false) {
        newState.dialog = null;
      }
      newState.dialog = {
        open: payload.open,
        type: payload.type,
        form: payload.form,
      };
      break;
    case CLASS_UNIT_OF_LEARNING_UPDATE_FORM:
      newState.unitOfLearning = { ...payload };
    break;
    default:
      break;
  }

  return newState;
};

export default classesReducer;
